export default "__VITE_ASSET__sCxNCHJR__"